import { render } from "./Space.vue?vue&type=template&id=033e2470"
import script from "./Space.vue?vue&type=script&lang=ts"
export * from "./Space.vue?vue&type=script&lang=ts"
script.render = render

export default script